// import React from 'react';
// import * as d3 from 'd3';
// import file from './MOCK_DATA.json';

// export default class Chart extends React.Component {
//     constructor(props){
//         super(props);
//         this.myRef = React.createRef();
//     }
    
//     componentDidMount() {
//         this.drawChart();
//       }
    
//     GetSortOrder(prop) {    
//         return function(a, b) {    
//             if (a[prop] < b[prop]) {    
//                 return 1;    
//             } else if (a[prop] > b[prop]) {    
//                 return -1;    
//             }    
//             return 0;    
//         }    
//     }    
    
//     drawChart() {

//         var x = file.map(i => ({
//             Perk: i['Perk Name'],
//             Amount: parseFloat(i['Amount'].substring(1))
//         }))
        

//         x.sort(this.GetSortOrder("Amount")); //Pass the attribute to be sorted on    

        
//         const data = x.slice(0,10).map(i => ({
//             Perk: i['Perk'],
//             Amount: i.Amount
//         }))

//         console.log(data);

//         const w = 960;
//         const h = 500;
//         const margin = {top:50, right:40, bottom:77, left:180};
//         const innerHeight = h - margin.top - margin.bottom;
//         const innerWidth = w - margin.left - margin.right;

//         const accessToRef = d3.select(this.myRef.current)
//             .append('svg')
//             .attr('width', w)
//             .attr('height', h)
        
//         const g = accessToRef.append('g')
//             .attr('transform', `translate(${margin.left}, ${margin.top})`);
        
//         const xScale = d3.scaleLinear()
//             .domain([d3.min(data, d=> d.Amount)-2, d3.max(data, d => d.Amount)+1])
//             .range([0, innerWidth]);
        
//         const yScale = d3.scaleBand()
//             .domain(data.map(d => d.Perk))
//             .range([0, innerHeight])
//             .padding(0.2);

//         const xAxis = d3.axisBottom(xScale)
//             .tickSize(-innerHeight);

//         const xAxisG = g.append('g').call(xAxis)
//             .attr('transform', `translate(-1,${innerHeight})`);
        
//         //xAxisG.select('.domain').remove();
        
//         xAxisG.append('text')
//             .attr('class', 'axis-label')
//             .attr('y', 60)
//             .attr('x', innerWidth / 2)
//             .attr('fill', 'black')
//             .text('Frequency');
        
//         g.append('g')
//             .call(d3.axisLeft(yScale))
//             .attr('transform', `translate(-1,0)`)
        
//         const barGroups = g.selectAll('rect')
//             .data(data)
//             .enter()
//             .append('rect')
        
//         barGroups
//             .attr('class', 'bar')
//             .attr('y', (d, i) => yScale(d.Perk))
//             .attr('width', (d) => xScale(0))
//             .attr('height', yScale.bandwidth())
//             .attr('fill', 'steelblue')
//             .on("mouseenter", function(actual, i){
//                 // d3.selectAll('.value')
//                 //     .attr('opacity', 1)
//                 d3.select(this)
//                     .transition()
//                         .duration(100)
//                     .attr('opacity', 0.6)
//                     .attr('y', (a) => yScale(a.Perk) - 5)
//                     .attr('height', yScale.bandwidth() + 10);
                
//                 g.append('line')
//                     .attr('class', 'limit')
//                     .attr('x1', xScale(actual.Amount))
//                     .attr('y1', 0)
//                     .attr('x2', xScale(actual.Amount))
//                     .attr('y2', innerHeight)

//             })
//             .on('mouseleave', function(){
//                 d3.select(this)
//                     .transition()
//                     .duration(200)
//                     .attr('opacity', 1)
//                     .attr('y', (a) => yScale(a.Perk))
//                     .attr('height', yScale.bandwidth())
//                 g.selectAll('.limit').remove()
//             })
        
//         g.selectAll("rect")
//             .transition()
//             .duration(400)
//             // .attr("x", function(d) { return innerWidth-xScale(d.Amount); })
//             .attr("width", function(d) { return xScale(d.Amount); })
//             .delay(function(d,i){console.log(i) ; return(i*100)})
          

//         // Bar Text
//         g.append("g")
//             .attr("fill", "#C0C0BB")
//             .attr("text-anchor", "end")
//             .attr("font-family", "sans-serif")
//             .attr("font-size", 6)
//             .selectAll("text")
//                 .data(data)
//                 .join("text")
//                 .attr("x", d => xScale(d.Amount))
//                 .attr("y", (d, i) => yScale(d.Perk) + yScale.bandwidth() / 2)
//                 .attr("dy", "0.35em")
//                 .attr("dx", -4)
//                 .text(d => d.Amount)
        
//         //Graph Title
//         g.append('text')
//             .attr('class', 'title')
//             .text('10 Most Used Perk Names')
//             .attr('y', -10)
//             .attr('font-size', 12);        
//     }

//     render() {
//         return <div ref={this.myRef}></div>
//     }
// }

import React, {Component} from "react";
import {Runtime, Inspector, Library} from "@observablehq/runtime";
import notebook from "@namitmohale/horizontal-bar-chart";

class PerkUtilizationReport extends Component {
    animationRef = React.createRef();
  
    componentDidMount() {
        const runtime = new Runtime().module(notebook, name => {
            if (name === "chart") {
            return new Inspector(this.animationRef.current);
            }
        });
        runtime.redefine("barTextSize", 6);
        runtime.redefine("titleTextSize", 6);
        // runtime.redefine("barHeight", 25);
        runtime.redefine("yAxisLabelSize", 5);
        runtime.redefine("data", [{
            Perk: 'Amazon',
            Amount: 14.99
        },
        {
            Perk: 'Spotify',
            Amount: 9.99
        },
        {
            Perk: 'Netflix',
            Amount: 8.99
        },
        {
            Perk: 'Dominos',
            Amount: 8.49
        },
        {
            Perk: 'Medium',
            Amount: 6.99
        }
        ]);
        runtime.redefine("width", 700);
        runtime.redefine("xAxisLabelSize", 5);
        runtime.redefine("xAxisNameSize", 6);
        // runtime.redefine("margin", ({top: 60, right: 100, left: 90, bottom: 80}));        
        
    }
  
    render() {
      return (
        <div style={{padding: 20}}>
          {/* <div ref={this.animationRef} style={{height: '60%', width: '60%'}}></div> */}
          <div ref={this.animationRef}></div>
        </div>
      );
    }
  }
  
  export default PerkUtilizationReport;